import { Helmet } from "react-helmet-async";
import { Container, Grid } from "@mui/material";
import OrdersTable from "./OrderListTable";
import PageTitleWrapper from "src/components/PageTitleWrapper";

function Orders() {
    return (
      <>
        <Helmet>
          <title>Orders</title>
        </Helmet>
        

        <Container  maxWidth="lg">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={3}
          >
            <Grid item xs={12}>
              <OrdersTable />
            </Grid>
          </Grid>
        </Container>
      </>
    );
  }
  
  export default Orders;